import { Box, Typography,  useTheme, useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import bankApp from '../img/bankistApp.png';
import yogantaram from '../img/yogantaram.png';
import myBus from '../img/myBus.png';
import trivago from '../img/trivago.png';
import seeMore from '../img/seeMore.png';
import { useContext } from "react";
import { themeContext } from "../context";

export default function Projects() {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    const themeHook = useTheme();
    const isSmallScreen = useMediaQuery(themeHook.breakpoints.down("md"));

    return (
        <Box id="Projects" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh', pt: 6 }}>
            {/* Heading */}
            <Typography component="span" sx={{ color: darkMode ? 'white' : 'black', fontSize: { xs: '1.5rem', md: '2.5rem' }, fontWeight: 'bold' }}>
                Recent Developed
            </Typography>
            <Typography component="span" sx={{ color: 'var(--orange)', fontSize: { xs: '2rem', md: '3rem' }, fontWeight: 'bold' }}>
                Projects
            </Typography>
            {/* Swiper */}
            <Swiper
                spaceBetween={0} // Set spaceBetween to 0 to remove extra margin
                slidesPerView={1}
                grabCursor={true}
                breakpoints={{
                    320: { slidesPerView: 2 },   // Adjusted slides per view for small screens
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 }
                }}
                className="projects-slider"
                style={{ marginTop: '3rem', width: '90%' }}
            >
                {[
                    { src: yogantaram, alt: "Yogantaram - WebApp for Yoga Therapist", link: "https://app.netlify.com/sites/yogantaramv1/" },
                    { src: myBus, alt: 'RedBus - Advance LLD', link: "https://bankist-application-lr.netlify.app/" },
                    { src: trivago, alt: "Trivago - Advance LLD", link: "https://advanced-lld-trivago.netlify.app/" },
                    { src: bankApp, alt: "Bank App", link: "https://bankist-application-lr.netlify.app/" },
                    { src: seeMore, alt: "See more ...", link: "provide-router-here-for-project-section" },
                ].map((project, index) => (
                    <SwiperSlide key={index}>
                        {project.link ? (
                            <a href={project.link} target='_blank' rel="noopener noreferrer">
                                <img src={project.src} alt={project.alt} style={{ width: '100%', maxWidth: '19rem', filter: 'drop-shadow(-8px 5px 3px rgba(0, 0, 0, 0.25))', borderRadius: '19px' }} />
                            </a>
                        ) : (
                            <img src={project.src} alt={project.alt} style={{ width: '100%', maxWidth: '19rem', filter: 'drop-shadow(-8px 5px 3px rgba(0, 0, 0, 0.25))', borderRadius: '19px' }} />
                        )}
                        {isSmallScreen ? <Typography sx={{ mt: 1, color: darkMode ? 'white' : 'grey', fontWeight: 'bold' }}>
                            {project.name || project.alt}
                        </Typography> : <Typography sx={{ mt: 1, color: darkMode ? 'white' : 'grey', fontWeight: 'bold', ml:project.alt.includes('LLD') ? 7.5 : (project.alt.includes('Yoga') ? 0 : 13), mr: project.alt.includes('Yoga') ? 17.5 : 0 }}>
                            {project.name || project.alt}
                        </Typography>}
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
}